import React from 'react';
import { InputField } from '../FormInputFields';
import { SearchIcon } from '../../helpers/icons';

let id;
const debouncedOnChange = (cb, t = 1200) => {
  return function (param) {
    if (id) {
      clearTimeout(id);
    }
    id = setTimeout(() => {
      cb(param);
    }, t);
  };
};

export const GlobalSearch = ({ setGlobalSearch = () => {} }) => {
  return (
    <div className="w-max--250 w--full inputIcon position--relative">
      <InputField
        placeholder="Search"
        // type="search"
        onChange={(e) =>
          debouncedOnChange((e) => setGlobalSearch(e.target.value))(e)
        }
      />
      <div className="position--absolute Icon text--black-300 c--pointer">
        <SearchIcon width={18} />
      </div>
    </div>
  );
};
